import React, { Fragment } from "react";
import styled from "styled-components";
import {StyleTooltip} from '../common';


const CustomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
  padding: 8px;
  margin: 0px 0px 1px;
  font: normal normal 600 1vw/1.1vw Open Sans;
  letter-spacing: 0px;
  background: #007842 0% 0% no-repeat padding-box;
  opacity: 1;
`;

const IconWrapper = styled.div`
  padding: 3px 15px 3px 15px;
  height: 100%;
  position: static;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  background: transparent url('/assets/wireless.png') 0% 0% no-repeat padding-box;
  color: #FFFFFF;
  cursor: pointer;
`;

const CardTitle = styled.div`
  text-align: left;
  font: normal normal 600 13px/18px Open Sans;
  letter-spacing: 0px;
  color: #FFFFFF; 
  opacity: 0.7;
  align-items: center;
  margin-left: 3px; 
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%-5px;
`;


export default function CommonTitleBar({
  title,
  icon,
  children,
  onClick
}) {
  return (
    <Fragment>
      <CustomContainer>
        <div style={{ display: "flex", alignItems: "center", maxWidth: "90%"}}>
          {icon ? (
            <IconWrapper>
              <img src={icon} alt="logo1" width="17" />
            </IconWrapper>
          ) : (
            <></>
          )}
          <StyleTooltip title={title}>
          <CardTitle>{title}</CardTitle>
          </StyleTooltip>
        </div>
        <div style={{display: "flex", alignItems: "right"}} onClick={onClick}>{children}</div>
        
      </CustomContainer>
    </Fragment>
  );
}
